import { Call, Device } from '@twilio/voice-sdk';
import { useEffect } from 'react';
import { CallButton, InboundCallStore, IncomingCallPopupStore } from '../../stores/LeadStore';

const deviceOptions = {
    closeProtection: false,
    edge: 'ashburn',
};

let phoneNumberInput: string;
let token: any;
let callingDeviceIdentity: any;
let device: Device;
let call: Call | null = null;
let inboundCall: Call | null = null;

function setClientNameUI(clientName: string) {
    console.log(`Your client name: ${clientName}`);
    //TODO: set it on the UI somewhere
}

export const setIdentity = async (identity: string) => {
    console.log('Setting Identity...' + identity);

    try {
        callingDeviceIdentity = identity;
        console.log('Identity: ' + callingDeviceIdentity);
    } catch (err) {
        console.log(err);
        console.log('An error occurred. See your browser console for more information.');
    }
};

// Instantiate a new Twilio.Device
export const intitializeDevice = (
    clientToken: string,
    identity: string,
    logLevel: 'trace' | 'debug' | 'info' | 'warn' | 'error' | 'silent',
) => {
    console.log('Initializing device');

    token = clientToken;

    device = new Device(token, { logLevel: logLevel });

    addDeviceListeners(device);

    setIdentity(identity);

    // Device must be registered in order to receive incoming calls
    device.register();
};

//Initiate token and start a call
export const intitializeDeviceAndStartCall = (
    clientToken: string,
    identity: string,
    logLevel: 'trace' | 'debug' | 'info' | 'warn' | 'error' | 'silent',
    toPhoneNumber: string,
    org: string,
    leadId: string,
    userId: string,
    callRecord: string,
    roomName: string,
) => {
    console.log('Initializing device');

    token = clientToken;

    device = new Device(token, { logLevel: logLevel });

    addDeviceListeners(device);

    setIdentity(identity);

    // Device must be registered in order to receive incoming calls
    device.register();

    //Make a call
    makeOutgoingCall(toPhoneNumber, org, leadId, userId, callRecord, roomName);
};

// Listen for Twilio.Device states
export const addDeviceListeners = (device: Device) => {
    device.on('registered', function () {
        console.log('Twilio.Device Ready to make and receive calls!');
    });

    device.on('error', function (error) {
        console.log('Twilio.Device Error: ' + error.message);
    });

    device.on('incoming', handleIncomingCall);
};

export const handleIncomingCall = (call: any) => {
    console.log(`Incoming call from ${call.parameters.From}`);
    inboundCall = call;

    //Search for the lead based on incoming phone number
    seachForInboundCallLeads(call.parameters.From);

    IncomingCallPopupStore.update((s) => {
        s.numberCalling = call.parameters.From;
    });
    IncomingCallPopupStore.update((s) => {
        s.showAnswerButton = true;
    });
    IncomingCallPopupStore.update((s) => {
        s.showRejectButton = true;
    });
    IncomingCallPopupStore.update((s) => {
        s.showHungupButton = false;
    });
    IncomingCallPopupStore.update((s) => {
        s.incomingCallDialogMode = true;
    });
    InboundCallStore.update((s) => {
        s.hasHungup = false;
    });

    // add event listener to call object
    call.on('cancel', handleDisconnectedIncomingCall);
    //call.on("disconnect", handleDisconnectedIncomingCall);
    call.on('reject', handleDisconnectedIncomingCall);
};

export const seachForInboundCallLeads = (phoneNumber: string) => {
    //Need to implement, maybe we just do this from a componenet when it loads?
};

// ACCEPT INCOMING CALL
export const acceptIncomingCall = () => {
    if (inboundCall != null) inboundCall.accept();
    //update UI, show hangup button
    IncomingCallPopupStore.update((s) => {
        s.showAnswerButton = false;
    });
    IncomingCallPopupStore.update((s) => {
        s.showHungupButton = true;
    });
    IncomingCallPopupStore.update((s) => {
        s.showRejectButton = false;
    });
    IncomingCallPopupStore.update((s) => {
        s.showSelectButton = true;
    });
    IncomingCallPopupStore.update((s) => {
        s.showCloseButton = false;
    });
};

// REJECT INCOMING CALL
export const rejectIncomingCall = () => {
    if (inboundCall != null) inboundCall.reject();
    IncomingCallPopupStore.update((s) => {
        s.showRejectButton = false;
    });
    IncomingCallPopupStore.update((s) => {
        s.showAnswerButton = false;
    });
    IncomingCallPopupStore.update((s) => {
        s.showHungupButton = false;
    });
    IncomingCallPopupStore.update((s) => {
        s.showCloseButton = false;
    });
    IncomingCallPopupStore.update((s) => {
        s.incomingCallDialogMode = false;
    });
};

// HANG UP INCOMING CALL
export const hangupIncomingCall = () => {
    if (inboundCall != null) inboundCall.disconnect();
    InboundCallStore.update((s) => {
        s.hasHungup = true;
    });
    IncomingCallPopupStore.update((s) => {
        s.showAnswerButton = false;
    });
    IncomingCallPopupStore.update((s) => {
        s.showHungupButton = false;
    });
    IncomingCallPopupStore.update((s) => {
        s.showRejectButton = false;
    });
    IncomingCallPopupStore.update((s) => {
        s.showCloseButton = true;
    });
};

// HANDLE DISCONNECTED INCOMING CALL
export const handleDisconnectedIncomingCall = () => {
    //Reset the UI
    IncomingCallPopupStore.update((s) => {
        s.showRejectButton = false;
    });
    IncomingCallPopupStore.update((s) => {
        s.showAnswerButton = false;
    });
    IncomingCallPopupStore.update((s) => {
        s.showHungupButton = false;
    });
    IncomingCallPopupStore.update((s) => {
        s.showCloseButton = false;
    });
    IncomingCallPopupStore.update((s) => {
        s.incomingCallDialogMode = false;
    });
};

// MAKE AN OUTGOING CALL

export const makeOutgoingCall = async (
    toPhoneNumber: string,
    org: string,
    leadId: string,
    userId: string,
    callRecord: string,
    roomName: string,
) => {
    console.log('Calling: ' + toPhoneNumber);
    console.log('From: ' + callingDeviceIdentity);

    const params = {
        To: toPhoneNumber,
        CallerId: callingDeviceIdentity,
        Org: org,
        LeadId: leadId,
        UserId: userId,
        Direction: 'OUTBOUND',
        NostraDirection: 'OUTBOUND',
        CallRecord: callRecord,
        RoomName: roomName,
    };

    if (device) {
        console.log(`Attempting to call ${params.To} ...`);

        //Twilio.Device.connect() returns a Call object
        //const call = await device.connect({ params });
        call = await device.connect({ params: params });
        // add listeners to the Call
        // "accepted" means the call has finished connecting and the state is now "open"
        call.on('accept', updateUIAcceptedOutgoingCall);
        call.on('error', updateUIError);
        call.on('disconnect', updateUIDisconnectedOutgoingCall);
        call.on('cancel', updateUIDisconnectedOutgoingCall);
        call.on('mute', updateUIMute);
    } else {
        console.log('Unable to make call.');
    }
};

export const callHangup = () => {
    console.log('Hanging up ...');
    if (call != null) call.disconnect();
};

export const callMute = () => {
    console.log('Muting ...');
    if (call != null) call.mute(true);
};

export const callUnMute = () => {
    console.log('Un Muting ...');
    if (call != null) call.mute(false);
};

export const sendDigits = (digit: string) => {
    console.log('Sending digit:' + digit + ' ...');
    if (call != null) call.sendDigits(digit);
};

function updateUIAcceptedOutgoingCall(call: any) {
    console.log('Call in progress ...');
    CallButton.update((s) => {
        s.showCallButton = false;
    });
    CallButton.update((s) => {
        s.showHangupButton = true;
    });

    CallButton.update((s) => {
        s.showCallingButton = false;
    });
    //CallButton.update(s => { s.showCallingButton = true }); TODO: Need to control this via signalR
}

function updateUIError(call: any) {
    console.log('There was an error with this call ...');
    //TODO: Log the error for review
}

function updateUIMute(isMuted: boolean, call: any) {
    if (isMuted) {
        console.log('Call was muted...');
    } else {
        console.log('Call was un-muted...');
    }
}

function updateUIDisconnectedOutgoingCall() {
    console.log('Call disconnected.');
    CallButton.update((s) => {
        s.showCallButton = true;
    });
    CallButton.update((s) => {
        s.showHangupButton = false;
    });
    CallButton.update((s) => {
        s.showOtherButtons = false;
    });
    CallButton.update((s) => {
        s.showCallingButton = false;
    });
}

export const sendSMS = () => {};
